import { type BridgeData } from '@databases/database-state/state/bridge-data';

import { getCurrentScope, setUser } from '@canvas/sentry-react';

export const configureSentry = ({
  cloudId,
  userId,
}: Pick<BridgeData, 'cloudId' | 'userId'>) => {
  getCurrentScope().setTag('cloudId', cloudId);
  setUser({ id: userId });
};
